import { render, staticRenderFns } from "./handmadePrescription.vue?vue&type=template&id=4bfa84d4&scoped=true"
import script from "./handmadePrescription.vue?vue&type=script&lang=js"
export * from "./handmadePrescription.vue?vue&type=script&lang=js"
import style0 from "./handmadePrescription.vue?vue&type=style&index=0&id=4bfa84d4&prod&lang=css"
import style1 from "./handmadePrescription.vue?vue&type=style&index=1&id=4bfa84d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa84d4",
  null
  
)

export default component.exports